import { render, staticRenderFns } from "./RtCommonFooterText.vue?vue&type=template&id=1d7f35dc&scoped=true"
import script from "./RtCommonFooterText.vue?vue&type=script&setup=true&lang=ts"
export * from "./RtCommonFooterText.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RtCommonFooterText.vue?vue&type=style&index=0&id=1d7f35dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7f35dc",
  null
  
)

export default component.exports